// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

import {
    createElement,
    Component,
    LocaleProvider,
    PropTypes,
} from '@plesk/ui-library';
import { Redirect } from 'react-router-dom';
import Plesk from './Plesk';
import PageContent from './PageContent';

class RequireComponent extends Component {
    state = {
        Component: null,
        data: {},
    };

    componentDidMount() {
        const { dataPath, componentPath } = this.props;

        // eslint-disable-next-line no-undef
        requirejs([componentPath], module => {
            this.setState({
                Component: module.default,
            });
        });
        this.loadData(dataPath);
    }

    componentWillReceiveProps({ dataPath }) {
        this.loadData(dataPath);
    }

    loadData(dataPath) {
        Plesk.getData(dataPath).then(data => this.setState({ data }));
    }

    render() {
        const { Component, data } = this.state;
        const { locale, status, pageTitle, breadcrumbs, ...props } = data;

        if (data.redirect) {
            const fullUrl = Jsw.baseUrl + data.redirect;

            return <Redirect to={fullUrl} />;
        }

        if (!Component || !locale || !props) {
            return null;
        }

        return (
            <LocaleProvider messages={locale}>
                <PageContent
                    title={pageTitle}
                    breadcrumbs={breadcrumbs}
                    statusMessages={status}
                >
                    <Component {...props} />
                </PageContent>
            </LocaleProvider>
        );
    }
}

RequireComponent.propTypes = {
    componentPath: PropTypes.string.isRequired,
    dataPath: PropTypes.string.isRequired,
};

export default RequireComponent;



// WEBPACK FOOTER //
// ./plesk/RequireComponent.js